const sectionSelector = '#main-blog-section';

(() => {
    function loadSection(url) {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newSection = doc.querySelector(sectionSelector);
                if (newSection) {
                    document.querySelector(sectionSelector).innerHTML = newSection.innerHTML;
                }
                history.pushState(null, '', url);
                // Re-attach event listeners to new links!
                attachFilterAndPaginationListeners();
            });
    }

    function attachFilterAndPaginationListeners() {
        // Filter links
        document.querySelectorAll('.blog-filter-link').forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                loadSection(this.href);
            });
        });
        // Filter links (mobile)
        document.getElementById('filter-blog-tags').addEventListener('change', function(e) {
            e.preventDefault();
            loadSection(this.value);
        });
        // Pagination links
        document.querySelectorAll('.pagination a').forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                loadSection(this.href);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Initial attach on page load
        attachFilterAndPaginationListeners();
    });
})();